import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { ContactResponse, ContactRequest } from '../models/contact/contact.model';
import { Utilities } from '../services/core/utilities';
import { ContactService } from '../services/contact.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'cp-root',
  templateUrl: './app.component.html',
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, OnDestroy {
  contactResponse: ContactResponse;
  modelReqDemo: any = {};
  modelContactUs: any = {};
  isSubmitClicked: boolean;
  isSuccess: boolean;
  constructor(private contactService: ContactService, private router: Router) {

  }

  ngOnDestroy(): void {

  }

  ngOnInit(): void {
    this.scrollTop();
    this.modelReqDemo.preferedTime = "Morning";
    this.isSubmitClicked = false;
    this.isSuccess = false;
  }

  private onDataLoadFailed(error: any): void {
    console.log(error);
  }

  private sendMail(result: ContactResponse): void {

    if (result.IsSuccess) {
      this.isSubmitClicked = false;
      this.isSuccess = true;
      setTimeout(() => {
        this.isSuccess = false;
        this.modelReqDemo = {};
        this.modelContactUs = {};
      }, 2000);
    }
  }

  sendMailDemoRequest(): void {
    this.isSubmitClicked = true;
    this.isSuccess = false;
    var contactRequest = new ContactRequest(Utilities.Email);
    
    var dialcode = '0';

    $("ul li").each(function (index) {
      if ($(this).attr('aria-selected') == 'true') {
        dialcode = $(this).find('span.iti__dial-code').text();   
      }      
    });

    this.modelReqDemo.telephone = dialcode + this.modelReqDemo.telephone;    
    setTimeout(() => {

      contactRequest.Subject = document.getElementById("RequestforDemo").innerText;
      contactRequest.HtmlContent = document.getElementById("requestDemo").innerHTML;
      this.contactService.sendEmail(contactRequest).subscribe(result => this.sendMail(result), error => this.onDataLoadFailed(error));

    }, 100);
  }

  sendMailContact(): void {
    this.isSubmitClicked = true;
    this.isSuccess = false;
    var contactRequest = new ContactRequest(Utilities.Email);
    contactRequest.Subject = document.getElementById("contact_info_send").innerText;
    contactRequest.HtmlContent = document.getElementById("contact_us").innerHTML;
    this.contactService.sendEmail(contactRequest).subscribe(result => this.sendMail(result), error => this.onDataLoadFailed(error));

  }

  private scrollTop(): void {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });

  }
}
